var map = {
	"./icon-3d-model.svg": 3956,
	"./icon-CA.svg": 4637,
	"./icon-DE.svg": 1724,
	"./icon-US.svg": 5365,
	"./icon-account.svg": 6342,
	"./icon-arrow--cta-long.svg": 4127,
	"./icon-arrow--cta.svg": 3556,
	"./icon-arrow--down.svg": 2142,
	"./icon-arrow--left.svg": 3669,
	"./icon-arrow--right.svg": 6504,
	"./icon-arrow--up.svg": 3829,
	"./icon-cart.svg": 867,
	"./icon-check--circle.svg": 1201,
	"./icon-checkmark.svg": 9924,
	"./icon-chevron-down.svg": 5415,
	"./icon-close.svg": 5295,
	"./icon-email.svg": 6087,
	"./icon-filters-sort.svg": 5215,
	"./icon-lock.svg": 4392,
	"./icon-minus-simple.svg": 3054,
	"./icon-minus.svg": 3663,
	"./icon-pause-home.svg": 5779,
	"./icon-pause.svg": 845,
	"./icon-play-home.svg": 3749,
	"./icon-play.svg": 6215,
	"./icon-playpause.svg": 463,
	"./icon-plus-simple.svg": 2232,
	"./icon-plus.svg": 5313,
	"./icon-remove.svg": 8417,
	"./icon-return.svg": 8039,
	"./icon-search.svg": 8397,
	"./icon-shipping.svg": 7971,
	"./icon-slider--left.svg": 3743,
	"./icon-slider--right.svg": 9850,
	"./icon-tail.svg": 1983,
	"./icon-tooltip.svg": 9898,
	"./icon-trail-marker.svg": 5734,
	"./icon-volume-mute.svg": 2111,
	"./icon-volume.svg": 3011,
	"./social-icons/icon-facebook.svg": 6710,
	"./social-icons/icon-instagram.svg": 7810,
	"./social-icons/icon-linkedin.svg": 3204,
	"./social-icons/icon-pinterest.svg": 1176,
	"./social-icons/icon-rss.svg": 6774,
	"./social-icons/icon-shopify-logo.svg": 884,
	"./social-icons/icon-snapchat.svg": 9980,
	"./social-icons/icon-tiktok.svg": 3540,
	"./social-icons/icon-tumblr.svg": 6992,
	"./social-icons/icon-twitter.svg": 2707,
	"./social-icons/icon-vimeo.svg": 1082,
	"./social-icons/icon-x.svg": 2870,
	"./social-icons/icon-youtube.svg": 7401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4078;